import { AdminType, APIDelete, APIGet, APIPost, APIPut, APIUrl } from "api/protocols";
import { CancelToken } from "axios";

export type TEmailTemplateType = "tee_sheet" | "reservation" | "league_announcement" | TEmailTemplateTypeAutomated;
export type TEmailTemplateTypeAutomated = "tee_sheet_booking_confirmation" | "tee_sheet_booking_cancellation" | "reservation_booking_confirmation" | "reservation_booking_cancellation" | "welcome_email" | "no_show_email" | "birthday_request_email";

export interface IEmailTemplate {
  id: number;
  automated: boolean;
  content: string;
  facility_id: number;
  subject: string;
  title: string;
  type: TEmailTemplateType;
}

export interface IEmailTemplateVariable {
  group: string;
  variables: Array<{label: string; token: string}>;
}

interface IGetEmailTemplate {
  id?: number;
  type?: TEmailTemplateType;
  automated?: boolean;
}

interface IPostEmailTemplate {
  title: string;
  type: TEmailTemplateType;
  subject: string;
  content: string;
  automated: boolean;
}

interface IPutEmailTemplate {
  id: number;
  title: string;
  type: TEmailTemplateType;
  subject: string;
  content: string;
  automated: boolean;
}

interface IDeleteEmailTemplate {
  id?: number;
}

export async function GetEmailTemplate(params: IGetEmailTemplate, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<Array<IEmailTemplate>>(APIUrl(AdminType.FacilityAdmin, "/facility/email-template"), params, useGlobalLoader, token);
}

export async function GetEmailTemplateVariables(useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<Array<IEmailTemplateVariable>>(APIUrl(AdminType.FacilityAdmin, "/facility/email-template/variables"), null, useGlobalLoader, token);
}

export async function PostEmailTemplate(params: IPostEmailTemplate, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/email-template"), params, useGlobalLoader);
}

export async function PostTestEmail(params: {content: string; subject: string; email: string; template_type: TEmailTemplateType}, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/email-template/test-email"), params, useGlobalLoader);
}

export async function PostPreviewEmail(params: {content: string; subject: string; template_type: TEmailTemplateType}, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/facility/email-template/preview-email"), params, useGlobalLoader);
}

export async function PutEmailTemplate(params: IPutEmailTemplate, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/facility/email-template"), params, useGlobalLoader);
}

export async function DeleteEmailTemplate(params: IDeleteEmailTemplate, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/facility/email-template"), params, useGlobalLoader);
}
